import React from 'react';
import { Body, Box, TextInput } from '@hover/blueprint';
import { ChangeHandler, RefCallBack } from 'react-hook-form';

interface Props {
  index: number;
  label: string;
  required: boolean;
  errorMessage: string;
  registerRef: {
    onChange: ChangeHandler;
    onBlur: ChangeHandler;
    ref: RefCallBack;
    name: string;
  };
}

const TextInputWithLabel: React.FC<Props> = ({
  index,
  label,
  errorMessage,
  registerRef,
  required,
}) => (
  <Box mb={index === 3 ? '56px' : 600} flexDir="column">
    {index > 3 && (
      <Body mb={100}>
        {label}
        {required && '*'}
      </Body>
    )}
    <TextInput
      borderColor={errorMessage ? 'orange.500' : 'neutral.300'}
      _placeholder={{
        color: errorMessage ? 'orange.600' : 'brandNavy.300',
        fontWeight: 700,
        letterSpacing: '0.1rem',
        fontSize: '12px',
      }}
      error={!!errorMessage}
      placeholder={index > 3 ? 'YOUR ANSWER' : `${label.toUpperCase()}*`}
      {...registerRef}
    />
    {!!errorMessage && (
      <Body isSemiBold mt={200} ml={200} size={300} color="danger.300">
        {errorMessage}
      </Body>
    )}
  </Box>
);

export default TextInputWithLabel;
